export default __webpack_public_path__ + "static/media/airdrop-popup-1.6f915035.webp";